// extracted by mini-css-extract-plugin
export default {"content":"Popover_content__fsnCv","trigger":"Popover_trigger__o7zXX","arrow":"Popover_arrow__GpVFn"};